<template>
    <div id="pageDashboard">
        <v-toolbar class="top-content" flat>
            <v-toolbar-title class="title-box pt-3">
                <span class="title">Sale Representative</span>
                <v-text-field @click:clear="searchSale" append-icon="search" class="inp-search" clearable
                    placeholder="Search" v-model="search" v-on:keydown="searchSale"></v-text-field>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog content-class="dialog-sale" max-width="450px" v-model="dialog" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-form ref="formSale" data-vv-scope="formSale" lazy-validation>
                    <v-card-text class="pt-0">
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex md12 xs12>
                                    <v-text-field
                                        :error-messages="errors.collect('formSale.name')"
                                        data-vv-name="name"
                                        label="Name"
                                        v-model="editedItem.name"
                                        v-validate="{required: true, max:50}"
                                        required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex md12 xs12>
                                    <v-text-field
                                            :error-messages="errors.collect('formSale.email')"
                                            data-vv-delay="500"
                                            data-vv-name="email"
                                            label="Email"
                                            v-if="editedIndex < 0"
                                            v-model="editedItem.email"
                                            v-validate="{required: true, regex: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/ ,max:100}"
                                    >
                                        <v-fade-transition leave-absolute slot="append">
                                            <v-progress-circular color="info" indeterminate size="24" v-if="validating"></v-progress-circular>
                                        </v-fade-transition>
                                    </v-text-field>
                                    <v-text-field
                                        :disabled="true"
                                        label="Email"
                                        v-if="editedIndex >= 0"
                                        v-model="editedItem.email"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialogConfirm = true" style="width: 85px">Cancel</v-btn>
                        <v-btn @click="save" color="primary" style="width: 85px">{{textBtn}}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog max-width="450px" v-model="dialogConfirm" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">Alert</span>
                </v-card-title>
                <v-card-text>{{ title2 }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
                    <v-btn @click="close" color="primary" style="width: 85px">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="moduleData"
            :loading="loading"
            :pagination.sync="pagination"
            :total-items="pagination.totalItems"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1 list-sale"
            item-key="name"
        >
            <template v-slot:headers="props">
                <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="['column', !(typeof header.sortable === 'boolean' && !header.sortable) ? 'sortable' : '', header.align ? header.align : 'text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                        @click="changeSort(header)"
                >
                    {{ header.text }}
                    <v-icon small v-if="!(typeof header.sortable === 'boolean' && !header.sortable)">arrow_upward</v-icon>
                </th>
            </template>
            <template slot="items" slot-scope="props">
                <tr :active="props.selected" @click="props.selected = !props.selected">
                    <td class="text-xs-left">{{ props.item.name}}</td>
                    <td class="text-xs-left">{{props.item.email }}</td>
                    <td class="text-xs-center">
                        <v-icon @click="editItem(props.item)" class="mr-2" small>edit</v-icon>
                    </td>
                </tr>
            </template>
            <template v-slot:actions-prepend>
                <div class="actions-list">
                    <v-btn @click="addSale" color="primary">Add</v-btn>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import SaleService from "../services/sale.service.js";
    import { debounce, isEmpty } from "lodash";
    export default {
        inject: ["$validator"],
        metaInfo() {
            return {
                title: "Manage Sale"
            };
        },
        data: () => ({
            dialogConfirm: false,
            pagination: {
                rowsPerPage: 10,
                page: 1
            },
            dialog: false,
            search: "",
            editedIndex: -1,
            editedItem: {
                name: null,
                email: "",
            },
            sortBy: "",
            actionSearch: false,
            loading: false,
            id: "",
            validating: false,
            saleService: new SaleService(),
            headers: [
                {
                    text: "Full Name",
                    value: "name"
                },
                { text: "Email", value: "email" },
                { text: "Action", sortable: false, align: "text-xs-center" }
            ],
            moduleData: [],
            rowsPerPageItems: [10, 20, 50],
            dictionary: {
            custom: {
                    "name": {
                        required: () => "The name field is required.",
                        max: () => "Max 50 characters"
                    },
                    "email": {
                        required: () => "The email field is required.",
                        max: () => "Max 100 characters"
                    }
                }
            },
        }),
        mounted() {},
        created() {},
        watch: {
            pagination: {
                handler() {
                    this.getData();
                },
                deep: true
            },
        },
        computed: {
            title2() {
                return this.editedIndex === -1 ? "Are you sure to cancel the new creation?" : "Are you sure to cancel the changes?";
            },
            formTitle() {
                return this.editedIndex === -1 ? "Add Sale" : "Edit Sale";
            },
            textBtn() {
                return this.editedIndex === -1 ? "Done" : "Save";
            },
            userInfo() {
            return this.$store.getters["auth/currentUser"];
            },
        },
        methods: {
            changeSort (data) {
                if (typeof data.sortable === 'boolean' && !data.sortable) return;
                const column = data.value;
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
                this.pagination.page = 1;
            },
            searchSale: debounce(function searchSale() {
                this.getData();
            }, 800),
            close() {
                this.dialog = false;
                this.dialogConfirm = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, {
                        name: "",
                        email: "",
                    });
                    this.editedIndex = -1;
                    this.$validator.reset();
                }, 500);
            },
            getData() {
                this.loading = true;
                let params = {
                    page: this.pagination.page,
                    limit: this.pagination.rowsPerPage,
                };
                if (!isEmpty(this.search)) params.search = this.search;
                if (this.pagination.sortBy) {
                    params.sort =
                        (this.pagination.descending ? "-" : "") +
                        this.pagination.sortBy;
                }
                this.saleService.getListSale(params).then(res => {
                    this.moduleData = res.docs;
                    this.loading = false;
                    this.pagination.totalItems = res.total;
                });
            },
            editItem(item) {
                this.editedIndex = this.moduleData.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.id = this.moduleData[this.editedIndex].id;
                this.dialog = true;
            },
            addSale() {
                this.dialog = true;
            },
            save() {
                this.$validator.validate('formSale.*').then(result => {
                    if (result) {
                        if (this.editedIndex === -1) {
                            this.saleService.add(this.editedItem).then(res => {
                                if (res.data && res.data.statusCode === 200) {
                                    this.close();
                                    this.getData();
                                } else {
                                    this.message = res.data.message;
                                }
                            });
                        } else {
                            this.saleService
                                .edit(this.editedItem, this.id)
                                .then(res => {
                                    if (res.data) {
                                        this.close();
                                        this.getData();
                                    }
                                });
                        }
                    }
                });
            },
        }
    }
</script>

<style>
li {
    text-decoration: none;
    list-style-type: none;
}

.list-poo img {
    max-width: 200px;
}

.dropbox {
    /*outline: 2px dashed grey; !* the dash box *!*/
    outline-offset: -10px;
    /*background: lightcyan;*/
    color: dimgray;
    padding: 10px 10px;
    /*min-height: 200px; !* minimum height *!*/
    position: relative;
    cursor: pointer;
}

.input-file {
    opacity: 0;
    /* invisible but it's there! */
    width: 100%;
    height: 50px;
    position: absolute;
    left: 10px;
    margin-top: 10px;
    top: 0;
    cursor: pointer;
}

.dropbox:hover {
    /*background: lightblue; !* when mouse over to the drop zone, change color *!*/
}

.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
}

.v-toolbar__content {
    /* height: 100% !important; */
}

/* @media screen and (max-width: 600px) {
     .inp-search {
        order: -1;
        flex: 1 0 100%;
    }
} */
table.v-table tbody td a {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87);
}

.title-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.inp-search {
    max-width: 440px;
    width: 100%;
}

.group-control {
    text-align: center;
}

#pageDashboard .v-datatable__actions {
    position: relative;
}

@media screen and (min-width: 1080px) {
    .actions-list {
        left: calc(50% - 55px);
    }
}

.actions-list {
    position: absolute;
    top: 5px;
}

.v-card__title {
    font-size: 18px;
    font-weight: bold;
    background-color: #f5f5f5;
}

.v-card__actions {
    padding: 15px 10px;
}

.top-content {
    background-color: #f5f5f5;
    color: rgba(0, 0, 0, 0.87);
}

table.v-table tbody td {
    word-break: break-word;
}

.list-survey tbody tr td:nth-child(1) {
    min-width: 150px;
}

.file-listing {
    display: flex;
}

.name-file {
    max-width: 260px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.accent--text {
    color: #0779ff !important;
}</style>